import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import CyberSecurity from "../Utiilities/CyberSecurity";
import DemoButtons from "../Utiilities/DemoButtons";
import LMS_Slider from "../Utiilities/LMS_Slider";
import AssetLogoslider from "../Utiilities/AssetLogoslider";
import Timesheetslider from "../Utiilities/Timesheetslider";
function OverviewCommonTS365(props) {
    const videoUrl = "https://youtu.be/fbMlyudySfk";
    const [isLightboxOpen, setLightboxOpen] = React.useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = React.useState('');
    const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
    const closeLightbox = () => {
        setLightboxOpen(false);
    };
    const getEmbedUrl = (url) => {
        if (url.includes('youtube.com/watch?v=')) {
            return url.replace('watch?v=', 'embed/');
        } else if (url.includes('youtu.be/')) {
            const videoId = url.split('youtu.be/')[1];
            return `https://www.youtube.com/embed/${videoId}`;
        } else if (url.includes('vimeo.com/')) {
            const videoId = url.split('vimeo.com/')[1];
            return `https://player.vimeo.com/video/${videoId}`;
        } else {
            return url; // fallback for direct video links
        }
    };
    const handlePlayClick = () => {
        setIsVideoPlaying(true); // When play icon is clicked, play the video
    };
    const handleCloseVideo = () => {
        setIsVideoPlaying(false); // Close the video
    };
    return (
        <>
            <div style={{ background: "none" }} className="overviewsection ETOverViewSection" >
                <h2 className="HR_heading" style={{ marginBottom: "0vw", color: "#333" }}>Stop Managing Time Across Spreadsheets and Disconnected Tools</h2>
                <p style={{ margin: "0" }}>Timesheet 365 brings all your time tracking into one centralized system, helping teams log work hours, maintain consistent timesheets, and track time across tasks.
                </p>
                <br></br>
                <p style={{ margin: "0" }}>With this unified platform, organizations gain better visibility into time usage, improve reporting accuracy, and ensure consistent time tracking across teams.
                </p>
                <p style={{ margin: "0" }}>With a structured approach to time tracking, organizations maintain accurate records, reduce manual effort, and gain clear visibility into how time is spent across projects.
                </p>

                <div style={{ margin: "1vw 0vw", display: "flex", justifyContent: "center", marginBottom: "1vw" }}>
                    <DemoButtons LMS365="LMS365" demobtnText="Explore Timesheet 365" />
                </div>
                <div>
                    <Timesheetslider />
                </div>
               
                </div>

        </>
    );
}

export default OverviewCommonTS365;
